import React, { useContext } from "react";
import DefaultRoutes from "templates/default/DefaultRoutes.jsx";
import { AuthContext } from "context/Authentication";
export default function AppRoutes(props) {
  const context = useContext(AuthContext);
  switch (process.env.TEMPLATE_NAME) {
    case "DEFAULT": {
      return <DefaultRoutes />;
    }
    
    default: {
      return <DefaultRoutes />;
    }
  }
}
